import Grid from "@mui/material/Unstable_Grid2";
import React, { useEffect, useState } from "react";
import { Box, Link } from "@mui/material";
import Modules from "../CustomisationSettings/Modules/Modules";
import Templates from "../CustomisationSettings/Templates/Templates";
import MainSettingMenu from "../MainSettingMenu/MainSettingMenu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { useNavigate } from "react-router-dom";
import PersonalSettings from "../GeneralSettings/PersonalSettings/PersonalSettings";
import Appearance from "../GeneralSettings/Appearance/Appearance";
import EmailSettings from "../GeneralSettings/EmailSettings/EmailSettings";
// import Currencies from "../MainSettingMenu/Currencies";
import Currencies from "../OrganisationSettings/Currencies/Currencies";
import Taxation from "../OrganisationSettings/Taxation/Taxation";
import OrganisationDetails from "../OrganisationSettings/OrganisationDetails/OrganisationDetails";
import Users from "../UserAndControl/Users/Users";
import AccessControl from "../UserAndControl/AccessControl/AccessControl";
import Branches from "../OrganisationSettings/Branches/Branches";
import Department from "../OrganisationSettings/Department/Department";
import Storage from "../DataAdmin/Storage/Storage";
import Export from "../DataAdmin/Export/Export";
import ActivityLog from "../DataAdmin/ActivityLog/ActivityLog";
import AuditLog from "../DataAdmin/AuditLog/AuditLog";
import EmployeePortal from "../PortalSetup/EmployeePortal/EmployeePortal";
import EmployerPortal from "../PortalSetup/EmployerPortal/EmployerPortal";
import Integrations from "../DeveloperSpace/Integrations/Integrations";
import ApiWebhooks from "../DeveloperSpace/ApiWebhooks/ApiWebhooks";

function SettingModulesForm() {
  const navigate = useNavigate();
  const [activePage, setActivePage] = React.useState("");
  const [section, setSection] = React.useState("");

  const updateMasterState = (attrName: any, value: any) => {
    setActivePage(value);
    // attrName(value);
    console.log(attrName, value);
  };

  useEffect(() => {
    const windowURL = window.location.search;
    const params = new URLSearchParams(windowURL);
    let selected_section = params.get("section");
    let page = params.get("page");
    setSection(selected_section ?? "");
    setActivePage(page ?? "");
  }, []);

  useEffect(() => {
    console.log(activePage);
  }, [activePage]);

  return (
    <Box className="newSettingWrapper h-100">
      <Grid xs={12}>
        <h3 className="pageTitle mb-7 ">
          <Link
            onClick={() => {
              navigate("/EmployerSettings");
            }}
          >
            <ChevronLeftIcon />
          </Link>
          Settings
        </h3>
      </Grid>
      <Grid container>
        <Grid xs sx={{ maxWidth: "250px" }}>
          {/* {section.length > 0 ? ( */}
          <MainSettingMenu
            section={section}
            attrName={setActivePage}
            value={activePage}
            value_update={updateMasterState}
          />
          {/* ) : null} */}
        </Grid>
        <Grid xs>
          {activePage === "modules" ? <Modules /> : null}
          {activePage === "templates" ? <Templates /> : null}
          {activePage === "personalSettings" ? <PersonalSettings /> : null}
          {activePage === "emailSettings" ? <EmailSettings /> : null}
          {activePage === "appearance" ? <Appearance /> : null}
          {activePage === "Currencies" ? <Currencies /> : null}
          {activePage === "Modules" ? <Modules /> : null}
          {/* {activePage === "OrganisationDetails" ? (
            <OrganisationDetails />
          ) : null} */}
          {activePage === "Taxation" ? <Taxation /> : null}
          {activePage === "CompanyDetails" ? <OrganisationDetails /> : null}
          {activePage === "users" ? <Users /> : null}
          {activePage === "Access" ? <AccessControl /> : null}
          {activePage === "Branches" ? <Branches /> : null}
          {activePage === "Departments" ? <Department /> : null}
          {activePage === "Storage" ? <Storage /> : null}
          {activePage === "Export" ? <Export /> : null}
          {activePage === "ActivityLog" ? <ActivityLog /> : null}
          {activePage === "AuditLog" ? <AuditLog /> : null}
          {activePage === "Employee" ? <EmployeePortal /> : null}
          {activePage === "Employer" ? <EmployerPortal /> : null}
          {activePage === "Integrations" ? <Integrations /> : null}
          {activePage === "Webhooks" ? <ApiWebhooks /> : null}
        </Grid>
      </Grid>
    </Box>
  );
}

export default SettingModulesForm;
